import { matchPath, useLocation } from 'react-router-dom';

/**
 * React Router v5 `useRouteMatch` compatibility shim built on v6/v7 `matchPath`.
 *
 * React Router v7 removed `useRouteMatch`. Every call site in this app uses it as
 * a boolean "is the current URL under this path?" check (`!!useRouteMatch(path)`),
 * sometimes against an array of paths. v5 matched by prefix (non-exact) by default,
 * so we pass `end: false` to `matchPath` to preserve that behaviour.
 *
 * Returns the first matching `match` object (or null), mirroring v5.
 */
export default function useRouteMatch(pathOrPaths) {
  const { pathname } = useLocation();
  const patterns = Array.isArray(pathOrPaths) ? pathOrPaths : [pathOrPaths];

  for (let i = 0; i < patterns.length; i++) {
    const match = matchPath({ path: patterns[i], end: false }, pathname);
    if (match) {
      return match;
    }
  }

  return null;
}
